import {Chip, ChipProps} from '@mui/material';

export type StatusIntent =
    | 'success'
    | 'warning'
    | 'error'
    | 'neutral'
    /** Brand / role tags (e.g. Admin) */
    | 'accent';

const intentColor: Record<StatusIntent, ChipProps['color']> = {
    success: 'success',
    warning: 'warning',
    error: 'error',
    neutral: 'default',
    accent: 'primary',
};

export type StatusChipProps = Omit<ChipProps, 'color' | 'size'> & {
    intent: StatusIntent;
};

/**
 * Status and role chips: consistent weight, casing, and small size.
 */
export const StatusChip = (props: StatusChipProps) => {
    const {intent, variant = 'filled', sx, ...rest} = props;
    return (
        <Chip
            color={intentColor[intent]}
            variant={variant}
            size="small"
            sx={[
                {
                    fontWeight: 600,
                    textTransform: 'capitalize',
                },
                ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
            ]}
            {...rest}
        />
    );
};
